/**
 * Mobile sticky add-to-cart: buy now, variant sync, sticky price
 */
(function () {
  const STICKY_ROOT = '#bls__sticky-addcart';
  const BUY_NOW_SELECTOR = '[data-sticky-buy-now]';
  const PAYMENT_BTN_SELECTOR =
    '.bls__product-dynamic-checkout .shopify-payment-button__button:not(.shopify-payment-button__button--hidden)';

  function getProductVariants() {
    const jsonEl = document.querySelector('[data-product-json]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent).variants;
    } catch (e) {
      return null;
    }
  }

  function formatStickyMoney(cents) {
    if (typeof Shopify === 'undefined' || !Shopify.formatMoney) return '';
    const moneyFormat =
      (typeof cartStrings !== 'undefined' && cartStrings?.money_format) ||
      window.theme?.moneyFormat ||
      '${{amount}}';
    return Shopify.formatMoney(cents, moneyFormat).replace(/,/g, '');
  }

  function updateStickyPrice(variant) {
    const priceRoot = document.querySelector('[data-sticky-price]');
    if (!priceRoot || !variant) return;

    const priceEl = priceRoot.querySelector('[data-sticky-price-value]');
    let badgeEl = priceRoot.querySelector('[data-sticky-pct-badge]');
    const priceRow = priceRoot.querySelector('.sticky-addcart-mobile__price-row');

    if (priceEl) {
      priceEl.textContent = formatStickyMoney(variant.price);
    }

    const onSale =
      variant.compare_at_price && variant.compare_at_price > variant.price;

    if (onSale) {
      const pct = Math.round(
        ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
      );
      if (!badgeEl && priceRow && pct > 0) {
        badgeEl = document.createElement('span');
        badgeEl.className = 'sticky-addcart-mobile__pct-badge';
        badgeEl.setAttribute('data-sticky-pct-badge', '');
        priceRow.appendChild(badgeEl);
      }
      if (badgeEl && pct > 0) {
        badgeEl.textContent = '-' + pct + '%';
        badgeEl.hidden = false;
      } else if (badgeEl) {
        badgeEl.hidden = true;
      }
    } else if (badgeEl) {
      badgeEl.hidden = true;
    }
  }

  function updateStickyPriceFromId(variantId) {
    const variants = getProductVariants();
    if (!variants) return;
    const variant = variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (variant) updateStickyPrice(variant);
  }

  function bindStickyPriceSync() {
    if (document.body.dataset.stickyPriceBound === 'true') return;
    document.body.dataset.stickyPriceBound = 'true';

    const mainIdInput = document.querySelector(
      '.bls__template-product form[data-type="add-to-cart-form"] input[name="id"]'
    );

    const onVariantChange = function () {
      if (mainIdInput && mainIdInput.value) {
        updateStickyPriceFromId(mainIdInput.value);
      }
    };

    if (mainIdInput) {
      mainIdInput.addEventListener('change', onVariantChange);
    }

    document.addEventListener('change', function (event) {
      const target = event.target;
      if (
        target &&
        target.matches &&
        target.matches('.bls__template-product .sticky-addcart-opstion')
      ) {
        onVariantChange();
      }
    });
  }

  function syncStickyVariantId(sticky) {
    const stickyVariantInput = sticky.querySelector('[data-sticky-variant-id]');
    const mainIdInput = document.querySelector(
      '.bls__template-product form[data-type="add-to-cart-form"] input[name="id"]'
    );
    if (!stickyVariantInput || !mainIdInput) return;

    const sync = function () {
      stickyVariantInput.value = mainIdInput.value;
      stickyVariantInput.disabled = mainIdInput.disabled;
      updateStickyPriceFromId(mainIdInput.value);
    };

    sync();
    mainIdInput.addEventListener('change', sync);
  }

  function copyCouponCode(btn) {
    const code = btn.getAttribute('data-coupon-code');
    if (!code) return;

    const copyLabel = btn.querySelector('[data-sticky-coupon-copy-text]');
    const copiedText = copyLabel?.getAttribute('data-copied-text') || 'Copied';

    const onSuccess = function () {
      try {
        localStorage.setItem('discount_code', code);
      } catch (e) {
        /* ignore */
      }
      btn.classList.add('is-copied');
      if (copyLabel) {
        if (!copyLabel.dataset.originalText) {
          copyLabel.dataset.originalText = copyLabel.textContent;
        }
        copyLabel.textContent = copiedText;
      }
      window.setTimeout(function () {
        btn.classList.remove('is-copied');
        if (copyLabel && copyLabel.dataset.originalText) {
          copyLabel.textContent = copyLabel.dataset.originalText;
        }
      }, 1800);
      notifyStickyHeightChange();
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(onSuccess).catch(function () {
        fallbackCopy(code, onSuccess);
      });
    } else {
      fallbackCopy(code, onSuccess);
    }
  }

  function fallbackCopy(text, onSuccess) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
      onSuccess();
    } catch (e) {
      /* ignore */
    }
    document.body.removeChild(ta);
  }

  function initStickyCoupon(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-sticky-coupon-copy]').forEach(function (btn) {
      if (btn.dataset.stickyCouponBound === 'true') return;
      btn.dataset.stickyCouponBound = 'true';
      btn.addEventListener('click', function () {
        copyCouponCode(btn);
      });
    });
  }

  function initStickyMobile(root) {
    const sticky = root || document.querySelector(STICKY_ROOT);
    if (!sticky) return;

    bindStickyPriceSync();
    syncStickyVariantId(sticky);
    initStickyCoupon(sticky);

    const buyNowBtn = sticky.querySelector(BUY_NOW_SELECTOR);
    if (!buyNowBtn || buyNowBtn.dataset.stickyBuyNowBound === 'true') return;

    buyNowBtn.dataset.stickyBuyNowBound = 'true';
    buyNowBtn.addEventListener('click', function () {
      const paymentBtn = document.querySelector(PAYMENT_BTN_SELECTOR);
      if (paymentBtn) {
        paymentBtn.click();
        return;
      }
      const productInfo = document.querySelector('.bls__product-details-infor');
      if (productInfo) {
        productInfo.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function notifyStickyHeightChange() {
    document.dispatchEvent(new CustomEvent('sticky-addcart:resize'));
  }

  function boot() {
    initStickyMobile(document.querySelector(STICKY_ROOT));
    const sticky = document.querySelector(STICKY_ROOT);
    if (sticky && typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(notifyStickyHeightChange);
      ro.observe(sticky);
    }
    notifyStickyHeightChange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const sticky = event.target.querySelector(STICKY_ROOT);
    if (sticky) initStickyMobile(sticky);
  });
})();
